// Build status for Kelly. Update this file as work is completed.
export const buildStatus = {
  asOf: 'October 10, 2026',
  done: [
    'Agent dashboard: "+ New Transaction" button (opens the new transaction page).',
    'Agent dashboard: sample transactions, shown only with ?sample=1 in the address (nothing saved).',
    'Buyer form: removed Down Payment Amount, Down Payment %, Loan Amount, Interest Rate %, Loan Term, Survey Required, Title Issues, and Homeowners Insurance Required.',
    'Buyer form: Home Inspection, Appraisal, and Financing deadline dates appear when each is checked.',
    'Buyer form: resale escrow deposit fields (first and second) appear when Resale is selected.',
    'Training: Agent Setup module with 34 steps, including Professional Profiles, Voicemail, Google Business Profile, Branding, ChatGPT images, Share Your Templates, and BoldTrail.',
    'Training: logos and Marketing Templates link added to Brand Standards; Marketing Center link added to Business Cards and Signs.',
  ],
  inProgress: [
    'Training is not yet split into Onboarding and Knowledge-based sections.',
    'Training content still to pull from the Wix programs (Kelly will log in to Wix so the content can be copied).',
  ],
  requested: [
    'Admin dashboard: send a notification to the RISE organization, the RESIDENCE organization, or the team, by email and text. Needs email and text (SMS) provider accounts.',
    'eXp Hub integration: post to the RISE and RESIDENCE groups. Waiting on the integration codes from Kelly.',
    'Offer Accepted: a button after a listing goes under contract, opening a purchase contract form. Waiting on the list of fields.',
    'Agent dashboard: load real transactions from the database (currently an empty list).',
    'Headshot photo received; waiting on how Kelly wants it used.',
  ],
  pending: [
    'RISE version of the training (separate content and steps).',
    'Agent Setup Welcome steps 2 to 4, and the Now What? section.',
    'eXp Hub and groups section, and the "Connect your MCP of Choice" step.',
    'YouTube playlist labels, Facebook tutorial links, and a welcome video placeholder.',
    'Firebase database rule for users/{uid}/training (check on first test).',
    'Run the site locally and confirm the Training page and buyer form work.',
  ],
};
